// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#new-design-frame[data-v-4ee2030d] {\n    border: 2px dashed #ACACAC;\n    height: 158px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 20px 0;\n}\n\n", ""]);
// Exports
module.exports = exports;
